var map = {
	"./arrow-right-circle.svg": "70be",
	"./arrow_down.svg": "4b1a",
	"./arrow_up.svg": "1ad6",
	"./bracket.svg": "a669",
	"./checkmark.svg": "1ec3",
	"./close.svg": "8b1b",
	"./cog.svg": "038c",
	"./column-stack.svg": "f425",
	"./compress-icon.svg": "331f",
	"./divide-solid.svg": "d9bb",
	"./exclamation-icon.svg": "1ea1",
	"./exclamation-triangle.svg": "6339",
	"./expand.svg": "8336",
	"./eye-cancelled.svg": "a3b7",
	"./eye.svg": "7364",
	"./eye_icon.svg": "2e83",
	"./gear.svg": "f571",
	"./light-bulb.svg": "84e7",
	"./magnifying-glass-right.svg": "fae0",
	"./metrics.svg": "9e78",
	"./minimize.svg": "6b30",
	"./minus-icon.svg": "7aa9",
	"./minus-solid.svg": "1824",
	"./options_icon.svg": "a334",
	"./pause.svg": "644b",
	"./pie_chart.svg": "d485",
	"./play.svg": "dab1",
	"./plus-icon.svg": "0a7c",
	"./plus-solid.svg": "baa1",
	"./protractor.svg": "95b5",
	"./refresh-icon-alt.svg": "e2be",
	"./refresh-icon.svg": "df44",
	"./search-icon.svg": "7669",
	"./server_icon.svg": "9bc1",
	"./space_rocket.svg": "7be4",
	"./speaker-low.svg": "b4e6",
	"./speaker-mute.svg": "f41d",
	"./speaker.svg": "5989",
	"./trash-icon.svg": "428f",
	"./user_icon.svg": "3963",
	"./vertical-dots.svg": "ff4c",
	"./video-snippet.svg": "27e9",
	"./xmark-solid.svg": "ea5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";